module.exports = __webpack_public_path__ + "images/emoji/jeans.da64039e56438f50bb8f.png";